/* unplugin-vue-components disabled */import script from "./toAmap.vue?vue&type=script&setup=true&lang=js"
export * from "./toAmap.vue?vue&type=script&setup=true&lang=js"

import "./toAmap.vue?vue&type=style&index=0&id=1e028d16&scoped=true&lang=scss"

import exportComponent from "D:\\00JH-项目\\钧舵机器人\\en\\jodell_robotics\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e028d16"]])

export default __exports__